import { ActiveDisplay } from '../../App/Displays/ActiveDisplay';

export interface MonitoringLog {
    logGUID: string;
    accountNumber: number;
    displaySerial?: string;
    incidentType: EventType;
    description?: string;
    resolution?: string;
    ticketId?: number;
    resolved: boolean;
    userName?: string;
    actionTime?: number;
}

export type MonitoringLogsByAccountNumber = {
    [key in Mri.Accounts.Account['accountNumber']]: MonitoringLog[];
};
export type MonitoringLogsByUser = {
    [key in Mri.Web.Internal.Controllers.Account.UserModel['userName']]: MonitoringLog[];
};
export type AccountContracts = {
    [key in Mri.Accounts.Account['accountNumber']]: Mri.Contracts.Contract[];
};

export interface DisplayPagingResponse extends Mri.WebApi.PagingResult<string> {
    displays: ActiveDisplay[];
}

export type ContractDisplays = {
    [key in Mri.Contracts.Contract['serviceCO']]: DisplayPagingResponse;
};

export type CustomerServiceRepresentative = Mri.Web.Internal.Controllers.Account.UserModel['userName'];
export type CustomerServiceRepresentativeAssignedAccounts = {
    [key in CustomerServiceRepresentative]: Mri.Accounts.Account['accountNumber'][];
};
export interface MonitoringStatusItem {
    accountNumber: Mri.Accounts.Account['accountNumber'];
    logGUID: string;
    lastUpdated: string;
}

export enum EventType {
    Monitoring = 0,
    Incident = 1,
    Ticket = 2,
    Other = 3,
}

export enum CustomerSupportAgents {
    'e08b2ebf-7c1b-44c1-882c-a31c3f8dfc20' = 'Test Agent',
}
